import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { IssuedStatusEnum, IExternalAccount } from '@/api/types';
import {
  getReportSearchForm,
  setReportSearchForm,
  removeReportSearchForm,
} from '@/utils/localstorage';
import { PlanAndUnitWithBookingType } from '@/utils/tickets';
import { formatDate } from '@/utils/index';

export class ReportSearchForm {
  public issuingDateRange: string[] = [naiveToday, naiveToday];
  public participationDateRange: string[] = [];
  public sourceIds: PlanAndUnitWithBookingType[] = [];
  public accountIds: IExternalAccount[] = [];
}

export interface IReportState {
  searchForm: ReportSearchForm;
}

const naiveToday = formatDate(new Date());

@Module({
  dynamic: true,
  name: 'report',
  store,
})
class ReportStore extends VuexModule implements IReportState {
  public searchForm = new ReportSearchForm();

  @Mutation
  private SET_REPORT_SEARCH_FORM(searchForm: ReportSearchForm) {
    this.searchForm = searchForm;
  }

  @Action
  public LoadReportSearchForm() {
    let searchForm = JSON.parse(
      getReportSearchForm() as string
    ) as ReportSearchForm;
    searchForm = searchForm || new ReportSearchForm();
    this.SET_REPORT_SEARCH_FORM(searchForm);
  }

  @Action
  public SaveReportSearchForm(searchForm: ReportSearchForm) {
    setReportSearchForm(JSON.stringify(searchForm));
    this.SET_REPORT_SEARCH_FORM(searchForm);
  }

  @Action
  public ClearReportSearchForm() {
    removeReportSearchForm();
    this.SET_REPORT_SEARCH_FORM(new ReportSearchForm());
  }

  @Action ClearReportStore() {
    this.ClearReportSearchForm();
  }
}

export const ReportModule = getModule(ReportStore);
